import type { ReactNode } from 'react';

/**
 * Screen-reader-only text. Per docs/design-system/components.md Tier 1 and
 * a11y.md §5 (accessible names on icon-only controls, live-region text, etc.)
 */
export function VisuallyHidden({ children }: { children: ReactNode }) {
  return (
    <span
      style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0,
      }}
    >
      {children}
    </span>
  );
}
